import { render, staticRenderFns } from "./RecruitButton.vue?vue&type=template&id=8a708e18"
import script from "./RecruitButton.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports